export const dbes = [
    "VPL only",
    "NPPL only",
    "NPPES only"
];
